import Vue from "vue";
import axios from "axios";
import "../../../../filters";
import moment from "moment";

const taskSelectionModeDef = {
  Single: { name: "Single", type: 0 },
  Property: { name: "Property", type: 1 },
  Customer: { name: "Customer", type: 2 },
};

export default {
  name: "SelectConnection",
  components: {
    DataGridComp: require("../../../../customcontrols/datagrid.vue").default,
    filterDataComp: require("../../../../customcontrols/filterData.vue")
      .default,
    SelectedMeterComp:
      require("@/customcontrols/selectedMeter/selectedMeter.vue").default,
  },
  props: {
    dataObj: {
      type: Object,
      required: true,
    },
    isOffline: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      connection: {},
      appId: -1,
      keyColumn: "connectionId",
      connections: [],
      currentConnections: [],
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      connectionsCols: [],
      noDataFound: false,
      filterObj: [],
    };
  },
  computed: {
    showSelectedPanel: function () {
      // return (
      //   (this.dataObj.currentConnections && this.dataObj.currentConnections.length > 0) ||
      //   (this.dataObj.connectionId != null && this.dataObj.connectionId != '' && this.dataObj.connectionId >= 0)
      // );
      if (this.dataObj.allowMultipleSelect)
        return (
          this.dataObj.currentConnections &&
          this.dataObj.currentConnections.length > 0
        );
      else
        return (
          this.dataObj.connectionId != null &&
          this.dataObj.connectionId != "" &&
          this.dataObj.connectionId >= 0
        );
    },
  },
  created() {
    //this.dataObj.isFieldWorker = false;
    this.$root.$on("select_connection_updated", this.init);
    this.fillConnectionsCols();
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;

        console.log(this.dataObj.currentConnections);
        if (
          this.dataObj.currentConnections &&
          this.dataObj.currentConnections.length > 0
        ) {
          this.dataObj.currentConnections.forEach((conn) =>
            this.dataObj.connectionIds.push(conn.connectionId)
          );

          if (this.dataObj.allowMultipleSelect)
            this.dataObj.connectionIds = this.dataObj.currentConnections;
          else {
            this.dataObj.connectionId =
              this.dataObj.currentConnections[0].connectionId;
          }
        }
        this.fillFiltersObj();
      });
    },
    pageChange(pInfo) {
      if (
        this.options.page == pInfo.pageNumber &&
        this.options.pageSize == pInfo.pageSize
      )
        return;

      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getConnections();
    },
    getConnections() {
      if (this.isOffline) {
        this.connections =
          this.$store.state.offlineApplicationsData.activityLookups[
            this.dataObj.appKey
          ]["connections"];

        // this.connections.forEach(
        //   (i) =>
        //     (i["lastReadingDateDisplay"] = moment(
        //       i.lastMeterReadingDate
        //     ).format("DD/MM/YYYY"))
        // );

        this.options.total = this.connections.length;
        this.totalRow = 0;
      } else {
        var criteria = {};

        for (var i = 0; i < this.filterObj.filter((a) => a.added).length; i++) {
          criteria[this.filterObj.filter((a) => a.added)[i].field] =
            this.filterObj.filter((a) => a.added)[i].value;
        }

        var parameters = {
          ApplicationId: this.appId,
          ApplicationKey: 0,
          Filters: criteria,
          Options: this.options,
        };

        this.$store.state.notifier.asyncBlock(
          axios.post("/SelectConnectionActivity/GetConnections", parameters),
          (response) => {
            if (response.status == 200) {
              console.log(response.data);
              response.data.items.forEach(
                (i) =>
                  (i["lastReadingDateDisplay"] = moment(
                    i.lastMeterReadingDate
                  ).format("DD/MM/YYYY"))
              );
              this.ResultColumns = [];
              let keys = Object.keys(Object.assign({}, ...response.data.items));

              for (let i = 0; i < keys.length; i++) {
                this.ResultColumns.push({
                  dataField: keys[i],
                  caption:
                    this.$t("activities." + keys[i]) == "activities." + keys[i]
                      ? keys[i]
                      : this.$t("activities." + keys[i]),
                });
              }

              if (response.data.items.length == 0) {
                this.connections = [];
                this.noDataFound = true;
              } else {
                this.connections = response.data.items;
                this.options.total = response.data.itemsCount;
                this.totalRow = response.data.itemsCount;

                if (this.connections.length == 1) {
                  var conn = this.connections[0];

                  this.connection.address = conn.address;
                  this.connection.bookNumber = conn.bookNumber;
                  this.connection.connection = conn.connection;
                  this.connection.connectionId = conn.connectionId;
                  this.connection.connectionNumber = conn.connectionNumber;
                  this.connection.connectionStatus = conn.connectionStatus;
                  this.connection.connectionStatusStr =
                    conn.connectionStatusStr;
                  this.connection.customerCellPhoneNumber =
                    conn.customerCellPhoneNumber;
                  this.connection.customerIdNumber = conn.customerIdNumber;
                  this.connection.customerKey = conn.customerKey;
                  this.connection.customerName = conn.customerName;
                  this.connection.customerTelephoneNumber =
                    conn.customerTelephoneNumber;
                  this.connection.fSequence = conn.fSequence;
                  this.connection.meter = conn.meter;
                  this.connection.meterId = conn.meterId;
                  this.connection.meterRef = conn.meterRef;
                  this.connection.meterType = conn.meterType;
                  this.connection.propertyId = conn.propertyId;
                  this.connection.propertyReference = conn.propertyReference;
                  this.connection.townId = conn.townId;
                  this.connection.townStr = conn.townStr;
                  this.connection.townshipId = conn.townshipId;
                  this.connection.townshipStr = conn.townshipStr;
                  this.connection.walkNumber = conn.walkNumber;

                  this.dataObj.connectionId = conn.connectionId;
                }
              }
              this.$root.$emit("datagrid_updated");
            }
          },
          (err) =>
            err.data == undefined
              ? this.$alertMsg(
                  `${this.$t("messages.apiRespondedWithCode")} ${
                    err.response.status
                  }`
                )
              : this.$alertMsg(err.data.data.text)
        );

        //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
        //axios.post('/SelectConnectionActivity/GetConnections', parameter)
        //  .then(response => {
        //    if (response.status == 200) {
        //      console.log(response.data);
        //      this.ResultColumns = [];
        //      let keys = Object.keys(Object.assign({}, ...response.data.items));

        //      for (let i = 0; i < keys.length; i++) {
        //        this.ResultColumns.push({ dataField: keys[i], caption: this.$t('activities.' + keys[i]) == 'activities.' + keys[i] ? keys[i] : this.$t('activities.' + keys[i]) });
        //      }

        //      if (response.data.items.length == 0) {
        //        this.connections = [];
        //        this.noDataFound = true;
        //      }
        //      else {
        //        this.connections = response.data.items;
        //        this.options.total = response.data.itemsCount;
        //        this.totalRow = response.data.itemsCount;

        //        if (this.connections.length == 1) {
        //          var conn = this.connections[0];

        //          this.connection.address = conn.address;
        //          this.connection.bookNumber = conn.bookNumber;
        //          this.connection.connection = conn.connection;
        //          this.connection.connectionId = conn.connectionId;
        //          this.connection.connectionNumber = conn.connectionNumber;
        //          this.connection.connectionStatus = conn.connectionStatus;
        //          this.connection.connectionStatusStr = conn.connectionStatusStr;
        //          this.connection.customerCellPhoneNumber = conn.customerCellPhoneNumber;
        //          this.connection.customerIdNumber = conn.customerIdNumber;
        //          this.connection.customerKey = conn.customerKey;
        //          this.connection.customerName = conn.customerName;
        //          this.connection.customerTelephoneNumber = conn.customerTelephoneNumber;
        //          this.connection.fSequence = conn.fSequence;
        //          this.connection.meter = conn.meter;
        //          this.connection.meterId = conn.meterId;
        //          this.connection.meterRef = conn.meterRef;
        //          this.connection.meterType = conn.meterType;
        //          this.connection.propertyId = conn.propertyId;
        //          this.connection.propertyReference = conn.propertyReference;
        //          this.connection.townId = conn.townId;
        //          this.connection.townStr = conn.townStr;
        //          this.connection.townshipId = conn.townshipId;
        //          this.connection.townshipStr = conn.townshipStr;
        //          this.connection.walkNumber = conn.walkNumber;

        //          this.dataObj.connectionId = conn.connectionId;
        //        }
        //      }
        //      this.$root.$emit('datagrid_updated');
        //    }
        //    else {
        //      this.$alertMsg(response.data.data.text, 1);
        //    }
        //    loader.hide();
        //  })
        //  .catch(error => {
        //    loader.hide();
        //    this.$alertMsg(error.response.statusText);
        //  });
      }
    },
    selectConnection() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Item: { ConnectionID: this.connection.connectionId },
      };

      this.$store.state.notifier.asyncBlock(
        axios.post("/SelectConnectionActivity/SelectConnection", parameter),
        (response) => {
          if (response.status == 200) {
            this.$alertMsg(this.$t("messages.SelectConnectionSuccess"), 2);
            this.dataObj.connectionId = this.connection.connectionId;
          }
        },
        (err) =>
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/SelectConnectionActivity/SelectConnection', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.$alertMsg(this.$t('messages.SelectConnectionSuccess'), 0);
      //      this.dataObj.connectionId = this.connection.connectionId;
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text, 1);
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //    this.$alertMsg(error.response.statusText);
      //  });
    },
    selectConnections() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Item: { ConnectionIDs: [] },
      };

      this.connectionIDs.forEach((con) => {
        parameter.Item.ConnectionIDs.push(con.connectionId);
      });

      this.$store.state.notifier.asyncBlock(
        axios.post("/SelectConnectionActivity/SelectConnections", parameter),
        (response) => {
          if (response.status == 200) {
            this.$alertMsg(this.$t("messages.SelectConnectionSuccess"), 2);
            this.dataObj.connectionId = this.connection.connectionId;
          }
        },
        (err) =>
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/SelectConnectionActivity/SelectConnections', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.$alertMsg(this.$t('messages.SelectConnectionSuccess'), 0);
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text, 1);
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //    this.$alertMsg(error.response.statusText);
      //  });
    },
    onSelectConnection(info) {
      var conn = info.data;

      if (this.dataObj.allowMultipleSelect) {
        this.dataObj.connectionIds.length = 0;
        this.dataObj.connectionIds.push(conn.connectionId);

        this.dataObj.currentConnections.length = 0;
        this.dataObj.currentConnections.push({
          connectionId: conn.connectionId,
          connection: conn.connection,
          propertyReference: conn.propertyReference,
          customerKey: conn.customerKey,
          address: conn.address,
        });
      } else {
        // this.dataObj.currentConnections = [{ ...conn }];

        this.dataObj.connectionId = conn.connectionId;

        this.dataObj.currentConnections.length = 0;
        this.dataObj.currentConnections.push({
          connectionId: conn.connectionId,
          connection: conn.connection,
          propertyReference: conn.propertyReference,
          customerKey: conn.customerKey,
          address: conn.address,
        });
      }

      this.$forceUpdate();
    },
    removeConnection(connectionId) {
      if (this.dataObj.allowMultipleSelect) {
        this.dataObj.currentConnections.splice(
          this.dataObj.currentConnections.indexOf(
            this.dataObj.currentConnections.filter(
              (a) => a.connectionId == connectionId
            )[0]
          ),
          1
        );
        this.dataObj.connectionIds.splice(connectionId, 1);
      } else {
        this.dataObj.currentConnections.length = 0;
        this.dataObj.connectionId = -1;
      }
    },
    fillConnectionsCols() {
      //this.dataObj.isFieldWorker = false;
      this.connectionsCols.push({
        dataField: "meterRef",
        caption: this.$t("activities.meterRef"),
      });
      this.connectionsCols.push({
        dataField: "address",
        caption: this.$t("activities.address"),
      });
      this.connectionsCols.push({
        dataField: "propertyReference",
        caption: this.$t("activities.propertyReference"),
      });
      this.connectionsCols.push({
        dataField: "connectionStatusStr",
        caption: this.$t("activities.status"),
      });
      // this.connectionsCols.push({
      //   dataField: "customerTelephoneNumber",
      //   caption: this.$t("activities.telNo"),
      // });
      this.connectionsCols.push({
        dataField: "lastMeterReadingReading",
        caption: this.$t("activities.LastMeterReading"),
      });
      this.connectionsCols.push({
        dataField: "lastReadingDateDisplay",
        caption: this.$t("activities.LastMeterReadingDate"),
      });

      if (this.dataObj.isFieldWorker == false) {
        this.connectionsCols.push({
          dataField: "connectionNumber",
          caption: this.$t("activities.conn"),
        });
        this.connectionsCols.push({
          dataField: "bookNumber",
          caption: this.$t("activities.bookNo"),
        });
        this.connectionsCols.push({
          dataField: "walkNumber",
          caption: this.$t("activities.walkNo"),
        });
        this.connectionsCols.push({
          dataField: "fSequence",
          caption: this.$t("activities.sequence"),
        });
        this.connectionsCols.push({
          dataField: "customerName",
          caption: this.$t("activities.tenant"),
        });
        this.connectionsCols.push({
          dataField: "customerKey",
          caption: this.$t("activities.tenantAccount"),
        });
        this.connectionsCols.push({
          dataField: "customerIdNumber",
          caption: this.$t("activities.idNo"),
        });
        this.connectionsCols.push({
          dataField: "ownerCustomerKey",
          caption: this.$t("activities.propertyOwnerCustomerKey"),
        });
      }
    },
    completeTask(info) {
      if (!this.dataObj.allowMultipleSelect) {
        this.dataObj.connectionId = info.data.connectionId;
        this.dataObj.completeTask();
      } else {
        var conn = info.data;

        if (
          this.dataObj.currentConnections.filter(
            (a) => a.connectionId == conn.connectionId
          ).length != 0
        ) {
          this.dataObj.connectionIds.push(conn.connectionId);
          this.dataObj.currentConnections.push({
            connectionId: conn.connectionId,
            connection: conn.connection,
            propertyReference: conn.propertyReference,
            customerKey: conn.customerKey,
            address: conn.address,
          });
          this.dataObj.completeTask();
        }
      }
    },
    fillFiltersObj() {
      this.filterObj.push({
        defaultIndex: 0,
        index: 0,
        field: "meterRef",
        fieldDesc: this.$t("activities.meterRef"),
        type: "text",
        addedDefault: true,
        defaultValue: "",
        value: "",
        added: true,
      });

      this.filterObj.push({
        defaultIndex: 1,
        index: 1,
        field: "address",
        fieldDesc: this.$t("activities.address"),
        type: "text",
        addedDefault: true,
        defaultValue: "",
        value: "",
        added: true,
      });

      this.filterObj.push({
        defaultIndex: 2,
        index: 2,
        field: "propertyReference",
        fieldDesc: this.$t("activities.propertyReference"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 3,
        index: 3,
        field: "connectionStatus",
        fieldDesc: this.$t("activities.status"),
        type: "list",
        listSource: [
          { text: this.$t("activities.ConnectedNoMeter"), id: "0" },
          { text: this.$t("activities.Connected"), id: "1" },
          { text: this.$t("activities.Disconnected"), id: "2" },
          { text: this.$t("activities.DisconnectedNoMeter"), id: "3" },
        ],
        listValueField: "id",
        listTextField: "text",
        addedDefault: false,
        defaultValue: "",
        value: "1",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 4,
        index: 4,
        field: "customerTelephoneNumber",
        fieldDesc: this.$t("activities.customerTelephoneNumber"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      //this.filterObj.push({
      //  defaultIndex: 5,
      //  index: 5,
      //  field: 'lastMeterReadingDate',
      //  fieldDesc: this.$t('activities.LastMeterReadingDate'),
      //  type: 'text',
      //  addedDefault: false,
      //  defaultValue: '',
      //  value: '',
      //  added: false
      //});

      this.filterObj.push({
        defaultIndex: 6,
        index: 6,
        field: "connectionNumber",
        fieldDesc: this.$t("activities.connectionNumber"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 7,
        index: 7,
        field: "ownerCustomerKey",
        fieldDesc: this.$t("activities.propertyOwnerCustomerKey"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 8,
        index: 8,
        field: "customerKey",
        fieldDesc: this.$t("activities.tenantAccount"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      //this.filterObj.push({
      //  defaultIndex: 9,
      //  index: 9,
      //  field: 'customerName',
      //  fieldDesc: this.$t('activities.tenantName'),
      //  type: 'text',
      //  addedDefault: false,
      //  defaultValue: '',
      //  value: '',
      //  added: false
      //});

      this.filterObj.push({
        defaultIndex: 10,
        index: 10,
        field: "customerIdNumber",
        fieldDesc: this.$t("activities.customerIdNumber"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 11,
        index: 11,
        field: "bookNumber",
        fieldDesc: this.$t("activities.bookNumber"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 12,
        index: 12,
        field: "walkNumber",
        fieldDesc: this.$t("activities.walkNumber"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 13,
        index: 13,
        field: "fSequence",
        fieldDesc: this.$t("captureMR.ColumnSequence"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      //Non Used Filters
      //this.filterObj.push(
      //  {
      //    defaultIndex: 0,
      //    index: 0,
      //    field: 'townId',
      //    fieldDesc: this.$t('activities.town'),
      //    type: 'list',
      //    listSource: this.dataObj.towns,
      //    listValueField: 'value',
      //    listTextField: 'text',
      //    addedDefault: false,
      //    defaultValue: '-1',
      //    value: '-1',
      //    added: false
      //  });

      //this.filterObj.push(
      //  {
      //    defaultIndex: 1,
      //    index: 1,
      //    field: 'townshipId',
      //    fieldDesc: this.$t('activities.township'),
      //    type: 'list',
      //    listSource: this.dataObj.townships,
      //    listValueField: 'value',
      //    listTextField: 'text',
      //    addedDefault: false,
      //    defaultValue: '-1',
      //    value: '-1',
      //    added: false
      //  });

      //if (this.dataObj.isFieldWorker != true) {
      //  this.filterObj.push({
      //    defaultIndex: 8,
      //    index: 8,
      //    field: 'customerIdNumber',
      //    fieldDesc: this.$t('activities.customerIdNumber'),
      //    type: 'text',
      //    addedDefault: false,
      //    defaultValue: '',
      //    value: '',
      //    added: false
      //  });

      //  this.filterObj.push({
      //    defaultIndex: 9,
      //    index: 9,
      //    field: 'propertyReference',
      //    fieldDesc: this.$t('activities.propertyReference'),
      //    type: 'text',
      //    addedDefault: false,
      //    defaultValue: '',
      //    value: '',
      //    added: false
      //  });
    },
  },
};
